import { motion } from "framer-motion";
import { useStepsQuery } from "@/lib/queries";
import { useSettings } from "@/context/SettingsContext";

export default function HowItWorks() {
  const { settings } = useSettings();
  const { data: steps = [] } = useStepsQuery();

  return (
    <section id="how" className="relative py-24 md:py-32 bg-[#0A0A0A]" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center mb-16">
          <div className="text-[0.7rem] tracking-[0.32em] uppercase text-[#D4AF37] font-semibold mb-4" data-testid="how-eyebrow">
            {settings?.how_eyebrow}
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white" data-testid="how-headline">
            {settings?.how_headline}
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-7 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

          <div className={`grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-4 ${steps.length === 5 ? "lg:grid-cols-5" : steps.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
            {steps.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative flex flex-col items-center text-center"
                data-testid={`step-${s.id}`}
              >
                <div className="relative z-10 w-14 h-14 rounded-full bg-[#0F0F0F] border border-[#D4AF37] text-[#D4AF37] font-serif text-lg flex items-center justify-center">
                  {s.number}
                </div>
                <h3 className="font-serif text-lg text-white mt-5">{s.title}</h3>
                <p className="text-sm text-white/55 mt-2 max-w-[240px]">{s.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
